/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { TableToggleRowsSelectedProps } from "react-table";
import { IndeterminateCheckbox } from "@nordcloud/gnui";

type Props = TableToggleRowsSelectedProps;

export function SelectionCell(props: Props) {
  return <IndeterminateCheckbox {...props} />;
}
